import React from 'react';

/* eslint react/prop-types: 0 */
const ImmediateFileUploaderCustomLayout = ({
  input,
  previews,
  dropzoneProps,
  files,
  extra: { maxFiles },
}) => (
  <div {...dropzoneProps} style={{
    borderWidth: 0,
    overflowX: 'hidden',
    overflowY: 'hidden',
  }}>
    {previews}
    {files.length < maxFiles && input}
  </div>
);

export default ImmediateFileUploaderCustomLayout;



// WEBPACK FOOTER //
// ./src/components/common/ImmediateFileUploaderCustomLayout.js